import { render, staticRenderFns } from "./downloadYearReport.vue?vue&type=template&id=d527d454&scoped=true"
import script from "./downloadYearReport.vue?vue&type=script&lang=js"
export * from "./downloadYearReport.vue?vue&type=script&lang=js"
import style0 from "./downloadYearReport.vue?vue&type=style&index=0&id=d527d454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d527d454",
  null
  
)

export default component.exports